import axios, { CancelToken } from 'axios'
import get from 'lodash/get'
import humps from 'humps'

import { getToken } from 'utils/auth'
import { BASE_URL } from 'utils/env'
import responseInterceptors from './responseInterceptors'

const instance = axios.create({
  transformRequest: [
    data => humps.decamelizeKeys(get(data, 'data')),
    ...axios.defaults.transformRequest,
  ],
  transformResponse: [...axios.defaults.transformResponse, data => humps.camelizeKeys(data)],
  baseURL: BASE_URL,
})

instance.interceptors.request.use(config => ({
  ...config,
  headers: { ...config.headers, authorization: `Bearer ${getToken()}` },
}))

instance.interceptors.response.use(...responseInterceptors)

export const getCanceller = () => CancelToken.source()

export default instance
